module.exports = {
          srcSet: __webpack_public_path__ + "9c6ec11b8f7739c1b9903864a857c845-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "9c6ec11b8f7739c1b9903864a857c845-1920.png",width: 1920,height: 563}],
          src: __webpack_public_path__ + "9c6ec11b8f7739c1b9903864a857c845-1920.png",
          toString:function(){return __webpack_public_path__ + "9c6ec11b8f7739c1b9903864a857c845-1920.png"},
          
          width: 1920,
          height: 563
        }